var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"track-by":"name","label":"name","options":_vm.options,"searchable":false,"allow-empty":false},scopedSlots:_vm._u([{key:"singleLabel",fn:function({ option }){return [_c('strong',[_vm._v(_vm._s(option.name))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }